import React from "react";
import PropTypes from "prop-types";
import { Header } from "../../Header";
import { Button, LottiePlayer } from "@learningblocks/shared-components";
import { Modal } from "@learningblocks/shared-components/lib/Modal";
import { RenderHTML } from "@learningblocks/shared-components";

import cname from "./style.module.scss";

export function PopupAnimation(props) {
  const lottieRef = React.useRef();
  const setStepDone = () => {
    setPlaybackComplete();
    props.onClose();
  };

  const setPlaybackComplete = () => {
    props.setWatched(true);
    if (props.closeOnComplete) {
      props.onClose();
    }
  };

  const autoPlay = () => {
    if (lottieRef.current && props.autoplay) lottieRef.current.onClickPlay();
  };

  const renderPopupModal = () =>
    props.open && (
      <Modal
        className={cname.popupAnimation}
        isOpen
        close={setStepDone}
        ariaLabel={props.ariaLabel}
      >
        <Header label={props.label} close={setStepDone} />
        <LottiePlayer
          ref={(ref) => (lottieRef.current = ref)}
          autoplay={props.autoplay}
          showControls={props.showControls}
          animationData={props.animationData}
          playbackCompleted={setPlaybackComplete}
          animationLoaded={autoPlay}
          className={cname.popupAnimation_content}
          stopOnLastFrame={props.stopOnLastFrame}
        />
        <div className={cname.popupAnimation_footer}>
          {props.noteText && (
            <p className={cname.text}>
              <RenderHTML content={props.noteText} />
            </p>
          )}
          <Button
            disabled={props.watched}
            onClick={setStepDone}
            className={cname.button}
          >
            Finish Step
          </Button>
        </div>
      </Modal>
    );

  return (
    <React.Fragment>
      {renderPopupModal()}
      {props.children}
    </React.Fragment>
  );
}

PopupAnimation.propTypes = {
  /**
   * Boolean for animtion-watched
   */
  watched: PropTypes.bool,
  /**
   * Callback to set animationWatched
   */
  setWatched: PropTypes.func,
  /**
   * Boolena to set Modal Open
   */
  open: PropTypes.bool,
  /**
   * Label to display on top of Moal
   */
  label: PropTypes.string,
  /**
   * Label to display for screen readers
   */
  altText: PropTypes.string,
  /**
   * Callback to the close button
   */
  onClose: PropTypes.func,
  /**
   * Animation data
   */
  animationData: PropTypes.object,
  /**
   * Element to which the Popup-Animation is coupled
   */
  childern: PropTypes.oneOfType([PropTypes.element, PropTypes.array]),
  /**
   * Autoplay the animation
   */
  autoplay: PropTypes.bool,
  /**
   * Shows Controls
   */
  showControls: PropTypes.bool,
  stopOnLastFrame: PropTypes.bool,
  closeOnComplete: PropTypes.bool,
  /**
   * Text to display as note
   */
  noteText: PropTypes.string,
};

PopupAnimation.defaultProps = {
  open: false,
  watched: false,
  autoplay: true,
  showControls: true,
  ariaLabel: "",
  stopOnLastFrame: false,
  closeOnComplete: false,
  noteText: "Note: you don't have to watch the full animation.",
};
